module.exports = __webpack_public_path__ + "img/Mesa3.55efaf07.png";